import "./Nav.scss";
import React from "react";

const Nav = (props: any) => {
  return (
    <nav style={{ zIndex: 9999 }} className="ct-bg-primary-500 ct-w-full ct-flex ct-space-x-2 ct-items-center ct-h-10 ct-px-3 ct-fixed ct-top-0">

      <img className="tnpLogo" src="nbcu-logo.png" alt="The Now Portal logo" />
      {props.children}
    </nav>
  );
};

export default Nav;
